import { KeyValueModel } from "../../model";
import { EnumTpServicoPedido } from "../../model/enums/enum-tp-servico-pedido";

export const TpServicoPedidoMock: KeyValueModel[] = [
  new KeyValueModel(EnumTpServicoPedido.Interno, "Interno"),
  new KeyValueModel(EnumTpServicoPedido.Polling, "Polling"),
  new KeyValueModel(EnumTpServicoPedido.GetPedido, "Get Pedido"),
  new KeyValueModel(EnumTpServicoPedido.WebHook, "WebHook"),
];
